import {
  TextField,
  Box,
  OutlinedTextFieldProps,
  InputLabelProps
} from "@material-ui/core"

import React from "react"
import CustomLabel from "./CustomLabel"
import Error from "./Error"
interface ICustomTextFieldProps extends Partial<OutlinedTextFieldProps> {
  readonly errorMsg?: string
  readonly labelProps?: InputLabelProps
  readonly warningMsg?: string
}
const CustomTextField: React.FunctionComponent<ICustomTextFieldProps> = ({
  label,
  className,
  onChange,
  type,
  required,
  multiline,
  error,
  disabled,
  errorMsg,
  labelProps,
  ...textFieldProps
}) => {
  return (
    <Box mb={2}>
      {label && (
        <CustomLabel disabled={disabled} required={required} {...labelProps}>
          {label}
        </CustomLabel>
      )}
      <Box bgcolor="white" borderRadius={4}>
        <TextField
          variant="outlined"
          fullWidth
          size="small"
          multiline={multiline}
          disabled={disabled}
          rows={5}
          type={type}
          onChange={onChange}
          error={!!errorMsg}
          {...textFieldProps}
        />
      </Box>
      <Error errorMsg={errorMsg} />
    </Box>
  )
}

export default CustomTextField
